import styled from 'styled-components';
import Button from '../../../../components/button/Button';
import ExpandCollapseTaskChecklistHeaders from './ExpandCollapseTaskChecklistHeaders';
import { LinkIcon } from '../../../../assets/icons/LinkIcon';
import { TabProps } from '../../../../blocks/tabs-vertical/TabsVertical';
import RadioButtons, { RadioButtonOptions } from '../../../../components/radio-buttons/RadioButtons';
import { useEffect, useState } from 'react';
import NotificationService from '../../../../services/NotificationService';
import LoadingOverlay from '../../../../components/loading-overlay/LoadingOverlay';
import MeterService from '../../../../services/MeterService';
import { log } from '../../../../utils/logging/log';
import TimeRegistrationService from '../../../../services/TimeRegistrationService';

const groupOptions = [
  { label: 'Måler skiftes', value: true },
  { label: 'Måler skiftes ikke', value: false }
] as RadioButtonOptions[];
interface Props extends TabProps {
  workTaskId?: string;
  wtmLink?: string;
  fetchTaskCallback: () => void;
}

const MeterTaskChecklistStep = (props: Props) => {
  const { wtmLink, workTaskId, fetchTaskCallback } = props;
  const [loading, setLoading] = useState(false);
  const [hoursOrGoodsRegistered, setHoursOrGoodsRegistered] = useState(false);
  const [canToggleMeterReplace, setCanToggleMeterReplace] = useState<boolean>();
  const [isReplacingMeter, setIsReplacingMeter] = useState<boolean>();

  useEffect(() => {
    if (!workTaskId) return;
    MeterService.getMeterTaskInfo(parseInt(workTaskId))
      .then((result) => {
        setCanToggleMeterReplace(result.meterReplacementInfo?.canToggleMeterReplace);
        setIsReplacingMeter(result.meterReplacementInfo?.isReplacingMeter);
      })
      .catch((e) => {
        log(e);
        NotificationService.error('Kunne ikke hente oplysninger fra WTM');
      });

    TimeRegistrationService.checkIfWorkTaskHasConsumedItemsOrTimeRegistrations(parseInt(workTaskId)).then((result) => {
      setHoursOrGoodsRegistered(result);
    });
  }, [workTaskId]);

  const confirm = () => {
    if (!workTaskId || isReplacingMeter === undefined) return;
    setLoading(true);
    MeterService.replaceMeter(parseInt(workTaskId), isReplacingMeter)
      .then(() => {
        NotificationService.success('Målerskifte registreret.');
        fetchTaskCallback();
      })
      .catch((e) => {
        log(e);
        NotificationService.error('Der sket en fejl. Målerskifte-registreringen kunne ikke gennemføres.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? (
        <LoadingOverlay />
      ) : (
        <>
          <ExpandCollapseTaskChecklistHeaders isCollapsable={false} header={'Målerdata'} readOnly>
            <MeterText>
              Åben WTM og udfyld den relevante målerdata. Vær opmærksom på, at linket åbner i din browser og du skal tilbage
              i Work, når du har udfyldt den relevante data
            </MeterText>
            <Button onClick={() => window.open(wtmLink, '_blank', 'noopener,noreferrer')}>
              <LinkIcon />
              Udfyld målerdata
            </Button>
          </ExpandCollapseTaskChecklistHeaders>
          {canToggleMeterReplace && (
            <ExpandCollapseTaskChecklistHeaders isCollapsable={false} header={'Målerskifte'} readOnly>
              <MeterText>Tag stilling til, om måler skal udskiftes eller ej.</MeterText>
              {hoursOrGoodsRegistered ? (
                <MeterText error>
                  Hvis du ændrer valget, vil fremtidige timer og varer blive registreret på et nyt projektnummer
                </MeterText>
              ) : null }
              <Row>
                <RadioButtons
                  options={groupOptions}
                  value={String(isReplacingMeter)}
                  handleValueChange={(value) => setIsReplacingMeter(value)}
                  labelPlacement="end"
                  row
                />
                <Button onClick={confirm} >
                  <LinkIcon />
                  Gem
                </Button>
              </Row>
            </ExpandCollapseTaskChecklistHeaders>
          )}
        </>
      )}
    </>
  );
};

const MeterText = styled.p<{ error?: boolean }>`
  margin: 15px 0px;
  color: ${(props) => (props.error ? props.theme.palette.functions.error.primary : 'black')};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default MeterTaskChecklistStep;
